"use client";

import Button from "@/components/atoms/Button";
import { Job } from "@/graphql/sdk/__generated__";
import { getPreviousApplication } from "@/helpers/cookies";
import { generateJobApplyUrl } from "@/helpers/url";
import { useTranslation } from "@/i18n/client";
import { AllowedLanguages } from "@/types/generic";

interface ApplyButtonProps {
  job: Job;
  locale: AllowedLanguages;
}

export const ApplyButton = ({ job, locale }: ApplyButtonProps) => {
  const { t } = useTranslation(locale);
  const previousApplication = getPreviousApplication(job.id);

  const dataLayerScript = `
      dataLayer.push({
        "event": "ecommerce",
        "eventCategory": "ecommerce",
        "eventAction": "start application",
        "eventLabel": "${job.id}",
        "ecommerce": {
          "add": {
            "products": [
              {
                "name": "${job.title}",
                "id": "${job.id}",
                "price": "10",
                "brand": "${job.office_id}",
                "category": "${job.sector_group}",
                "quantity": 1
              }
            ]
          }
        }
      });
    `;

  const handleApplyButtonClick = () => {
    const script = document.createElement("script");
    script.text = dataLayerScript;
    document.head.appendChild(script);
  };

  return (
    <>
      {previousApplication ? (
        <Button
          as="link"
          href={`/${locale}/myvivaldis`}
          className="btn-lg btn-outline w-full sm:w-auto"
        >
          {t("job.btn.check_application_status")}
        </Button>
      ) : (
        <Button
          as="link"
          href={generateJobApplyUrl(locale, job.id)}
          className="btn-lg w-full sm:w-auto"
          onClick={() => {
            handleApplyButtonClick();
          }}
        >
          {t("job.btn.apply")}
        </Button>
      )}
    </>
  );
};

export default ApplyButton;
